"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = void 0;
var actionTypes = {
  FETCH: "@@platform-key/fetch",
  TENANT_DETAILS: "@@platform/tenant-details",
  APIURL: "@@platform/apiurl",
  ADD: "@@platform-key/add",
  RESET: "@@platform-key/reset",
  SUCCESS: "@@platform-key/success",
  ERROR: "@@platform-key/error"
};
exports.actionTypes = actionTypes;